module.exports = __webpack_public_path__ + "static/media/05 Minutes of Meeting 01 Aug 2023.333d7783.pdf";